import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KlaviyoClient } from './klaviyo.client';
import { Config } from '../points-of-interest/models/config';
import { KlaviyoService } from './klaviyo.service';
import { Actions, NgxsModule, Store } from '@ngxs/store';

@NgModule({
  declarations: [],
  imports: [CommonModule, NgxsModule]
})
export class KlaviyoModule implements ModuleWithProviders<KlaviyoModule> {
  ngModule: Type<any>;

  static forRoot(config: any = {}): ModuleWithProviders<KlaviyoModule> {
    return {
      ngModule: KlaviyoModule,
      providers: [
        Store,
        Actions,
        { provide: Config, useValue: config },
        { provide: KlaviyoClient, useValue: new KlaviyoClient(config['klaviyoToken']) },
        KlaviyoService
      ]
    };
  }

  public constructor(klaviyoService: KlaviyoService) {
    klaviyoService.startTracking();
  }
}
